/**
 * The /items/$itemId search params and the tab list they are checked against.
 *
 * `pricing` sits next to `cost` on purpose: Maliyet answers "what did this cost
 * us", Satış fiyatı answers "what must we charge", and the second reads the first.
 *
 * Apart from the card for the same reason W-06's and W-07's parsers are:
 * `validateSearch` runs in the route module the router loads eagerly, so reading
 * `ITEM_TABS` from `item-detail-page.tsx` pulled the whole card — its nine tabs
 * and the item form drawer — into the initial bundle.
 */
export const ITEM_TABS = ['general', 'stock', 'bom', 'cost', 'pricing', 'amazon', 'suppliers', 'movements', 'documents'] as const;
export type ItemTab = (typeof ITEM_TABS)[number];

export interface ItemDetailSearch {
  tab?: ItemTab;
  /** BOM version number the Ürün ağacı tab shows (default: active, else the newest). */
  v?: number;
}

export function parseItemDetailSearch(s: Record<string, unknown>): ItemDetailSearch {
  return {
    tab: (ITEM_TABS as readonly string[]).includes(s.tab as string) ? (s.tab as ItemTab) : undefined,
    v: typeof s.v === 'number' ? s.v : typeof s.v === 'string' && /^\d+$/.test(s.v) ? Number(s.v) : undefined,
  };
}
